export class ReflectorDataNotFoundError extends Error {
	public constructor() {
		super('The requested data could not be found');
	}
}
